import { AppPage } from 'interfaces'
import React from 'react'

import StudentWorkAtSection from '../components/StudentWorkAtSection'
import BootcampStartNotificationSection from '../sections/common/BootcampStartNotificationSection'
import CurriculumSection from '../sections/common/CurriculumSection'
import FaqSection from '../sections/common/FaqSection'
import FeedBackSection from '../sections/common/FeedBackSection'
import FullBootCampSection from '../sections/common/FullBootCampSection'
import HeroSection from '../sections/common/HeroSection'
import PricingSection from '../sections/common/PricingSection'
import QuerySection from '../sections/common/QuerySection'
import VideoSection from '../sections/common/VideoSection'
import WhatYouGetSection from '../sections/common/WhatYouGetSection'

const FrontendBootcamp: AppPage = () => {
  return (
    <div className="pb-10">
      <HeroSection type={'frontend'} />
      <VideoSection showLearnWith={true} type={'frontend'} />
      <WhatYouGetSection type={'frontend'} />
      <CurriculumSection type={'frontend'} />
      <StudentWorkAtSection />
      <FeedBackSection />
      <PricingSection type={'frontend'} />
      <FullBootCampSection />
      <FaqSection />
      <BootcampStartNotificationSection type={'frontend'} />
      <QuerySection />
    </div>
  )
}

FrontendBootcamp.seo = {
  title: 'Frontend Bootcamp | Devsnest'
}

FrontendBootcamp.layout = {
  screenWidth: true
}

export default FrontendBootcamp
